/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { Channel } from 'types';

const find = async (broadcastingId: number): Promise<Channel[]> => {
  let pathUrl = broadcastingId || 100002;
  const response = await callApiEndpoint('canali/' + pathUrl + '/findByOrganizationIdDeep', {
    params: {},
    // organizationId: broadcastingId,
  });
  return response.map(utils.toChannel);
};

export default {
  find,
};
